import styled from 'styled-components';

import { FolderCard } from 'ui/card';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { colors, mediumShadow, smallShadow, spacing } from 'ui/theme';
import { link2 } from 'ui/theme/typography';
import { SearchParamLink } from 'ui/utility/SearchParamLink/SearchParamLink';
import { useSelectionContext } from '../../../contexts/SelectionContext';
import { AssetSubfolder } from 'modules/creativeLibrary/types';
import { FOLDER_ID_SEARCH_PARAM, PAGE_SEARCH_PARAM } from 'modules/creativeLibrary/constants';
import { useState } from 'react';
import { FolderActionMenu } from '../common/FolderActionMenu';
import { isSelectionFolder } from 'utils/contexts/selection';

const FolderMenuContainer = styled.div`
  position: absolute;
  right: ${spacing.half};
  top: ${spacing.quarter};
`;

const StyledFolderCard = styled(FolderCard)`
  ${smallShadow};
  background: ${colors.white};
  border-radius: ${spacing.half};
  padding-bottom: ${spacing.quarter};
  position: relative;
  outline: none;
  &:hover {
    ${mediumShadow};
  }
  ::before {
    border: ${spacing.quarter} solid ${colors.purple50};
    border-radius: ${spacing.threeQuarter};
    inset: -${spacing.quarter};
    content: '';
    display: block;
    visibility: ${({ $isSelected }: { $isSelected: boolean }) =>
      $isSelected ? `visible` : `hidden`};
    position: absolute;
    transition: all 0.2s;
    z-index: -1;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  margin: ${spacing.base};
  margin-right: 0;
`;

const StyledSearchParamLink = styled(SearchParamLink)`
  ${link2};
  text-decoration-color: transparent;
  color: ${colors.textPrimary};
  font-weight: 400;
`;

export const FolderCardItem = ({
  folder,
  isPanel,
  hasManageBaseTemplatesPermission,
}: {
  folder: AssetSubfolder;
  isPanel: boolean;
  hasManageBaseTemplatesPermission: boolean;
}) => {
  const { id, name } = folder;
  const { bulk, toggleBulkSelection } = useSelectionContext();
  const isSelected =
    bulk.findIndex((selected) => isSelectionFolder(selected) && selected.id === id) > -1;
  const [showActions, setShowActions] = useState(false);

  return (
    <StyledFolderCard
      Prefix={
        !isPanel &&
        hasManageBaseTemplatesPermission && (
          <StyledCheckbox
            id={`folder-card-${id}-checkbox`}
            data-test={`folder-card-${id}-checkbox`}
            status={isSelected ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED}
            tabIndex={undefined}
            onClick={() => toggleBulkSelection(folder)}
          />
        )
      }
      hasBoxShadow
      shouldHover
      $isSelected={isSelected}
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      <StyledSearchParamLink
        searchParams={{
          [FOLDER_ID_SEARCH_PARAM]: id.toString(),
        }}
        deleteSearchParams={[PAGE_SEARCH_PARAM]}
      >
        {name}
      </StyledSearchParamLink>
      {!isPanel && showActions && hasManageBaseTemplatesPermission && (
        <FolderMenuContainer>
          <FolderActionMenu folder={folder} />
        </FolderMenuContainer>
      )}
    </StyledFolderCard>
  );
};
